import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IPage, IPageSize, ISort, TDefaultStoreNoSearchDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

const initialState: TDefaultStoreNoSearchDTO = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
};

const organisationSettings = createSlice({
	name: 'organisationSettings',
	initialState,
	reducers: {
		setPage: (state, action: PayloadAction<IPage>) => {
			state.page = action.payload.page;
		},
		setPageSize: (state, action: PayloadAction<IPageSize>) => {
			state.pageSize = action.payload.pageSize;
			state.page = initialState.page;
		},
		setSort: (state, action: PayloadAction<ISort>) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		resetOrganisationSettingsTable: () => {
			return { ...initialState };
		},
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
} = organisationSettings.actions;

export default organisationSettings.reducer;
